import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
} from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MomentUtils from "@date-io/moment";
import moment from "moment";

const EvaluationManagementForm = ({ newEvaluation, close, open }) => {
  const { t } = useTranslation();

  const [transitionTime, setTransitionTime] = useState(new Date());
  const [reminder, setReminder] = useState(new Date());
  const [dateError, setDateError] = useState(false);

  useEffect(() => {
    let isValid = false;
    if (moment(reminder).isValid() && moment(transitionTime).isValid()) {
      if (
        moment(reminder).isAfter(new Date()) &&
        moment(transitionTime).isAfter(new Date())
      ) {
        isValid = true;
      }
    }
    setDateError(!isValid);
  }, [transitionTime, reminder]);

  return (
    <Dialog open={open} fullWidth maxWidth={"xs"}>
      <DialogTitle id="form-dialog-title">Nueva formación online</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Selecciona la fecha de caducidad del curso
        </DialogContentText>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <KeyboardDatePicker
                autoOk
                variant="inline"
                inputVariant="outlined"
                label="Recordatorio"
                format="YYYY/MM/DD"
                fullWidth
                value={reminder}
                minDate={new Date()}
                invalidDateMessage={t("invalidDate")}
                minDateMessage={t("minDateMessage")}
                InputAdornmentProps={{ position: "end" }}
                onChange={(date) => {
                  setReminder(date);
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <DialogContentText>
                Selecciona la fecha del final de transición
              </DialogContentText>
            </Grid>

            <Grid item xs={12}>
              <KeyboardDatePicker
                autoOk
                variant="inline"
                inputVariant="outlined"
                label="Fecha entrada en vigor"
                format="YYYY/MM/DD"
                fullWidth
                minDate={new Date()}
                invalidDateMessage={t("invalidDate")}
                minDateMessage={t("minDateMessage")}
                value={transitionTime}
                InputAdornmentProps={{ position: "end" }}
                onChange={(date) => {
                  setTransitionTime(date);
                }}
              />
            </Grid>
          </Grid>
        </MuiPickersUtilsProvider>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          style={{ textTransform: "none" }}
          onClick={close}
        >
          {t("cancel")}
        </Button>
        <Button
          color="primary"
          variant="contained"
          style={{ textTransform: "none" }}
          disabled={dateError}
          onClick={() => newEvaluation(reminder, transitionTime)}
        >
          Crear nueva formación
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EvaluationManagementForm;
